import React, { useState } from "react";
import { Brand } from "./shared/Brand";
import { Footer } from "./sections/Footer";
import { Reveal } from "./shared/Reveal";
import WhatsAppButton from "./WhatsAppButton";
import GapFloat from "./GapFloat";

const CATEGORIES = [
  ["Refrigeration Systems", ["Cold Stores", "Blast Freezers", "Chillers", "Ammonia Systems", "CO₂ Systems"]],
  ["Water Systems", ["Boreholes", "Pumps", "Water Treatment", "Filtration", "Cooling Towers"]],
  ["Compressed Air", ["Compressors", "Air Dryers", "Air Receivers", "Distribution Systems"]],
  ["Steam & Boilers", ["Steam Boilers", "Hot Water Boilers", "Heat Exchangers"]],
  ["HVAC", ["Air Handling Units", "Ventilation", "Air Conditioning", "Heating Systems"]],
  ["Manufacturing", ["Production Lines", "Conveyors", "Packaging", "Robotics", "Process Equipment"]],
  ["Electrical Infrastructure", ["Transformers", "Switchgear", "Distribution Boards", "Motors", "Variable Speed Drives"]],
  ["Renewable Energy", ["Solar PV", "Battery Storage", "EV Charging", "Heat Pumps"]],
];

const BENEFITS = [
  "Reduce energy costs", "Reduce water consumption", "Carbon & ESG reporting", "Predictive maintenance",
  "Automated alerts", "Real-time dashboards", "Asset performance monitoring", "Operational intelligence",
  "Continuous verification of savings", "Minute-by-minute reporting",
];

function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <nav className="evnav">
      <div className="wrap navin">
        <a href="/"><Brand /></a>
        <div className="navlinks">
          <a href="/">Home</a>
          <a href="/how-it-works">How It Works</a>
          <a href="/#audio">Audio Library</a>
          <a href="/#solar-installs">Install Services</a>
          <a href="/gap-analysis-pages">Gap Analysis Pages</a>
          <a href="/marketing">Marketing</a>
          <a href="/#contact" className="btn" style={{ padding: "10px 20px" }}>Complimentary Gap Analysis</a>
        </div>
        <button className="navtoggle" onClick={() => setOpen((o) => !o)} aria-label="Menu" aria-expanded={open}>
          {open ? (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          ) : (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
          )}
        </button>
      </div>
      {open && (
        <div className="navmobile">
          <a href="/">Home</a>
          <a href="/how-it-works">How It Works</a>
          <a href="/#audio">Audio Library</a>
          <a href="/#solar-installs">Install Services</a>
          <a href="/gap-analysis-pages">Gap Analysis Pages</a>
          <a href="/marketing">Marketing</a>
          <a href="/#contact" className="btn">Complimentary Gap Analysis</a>
        </div>
      )}
    </nav>
  );
}

export default function AssetsPage() {
  return (
    <div className="evg">
      <Nav />

      <header className="prodhero">
        <div className="wrap">
          <Reveal className="eyebrow" tag="div" style={{ textAlign: "left" }}>OPERATIONAL INTELLIGENCE · WHAT WE MONITOR</Reveal>
          <Reveal tag="h1">Every Building Has <span className="g">Hidden Opportunities</span></Reveal>
          <Reveal className="intro" tag="p">
            If you have any of these systems, there's a strong possibility we can <b>reduce operating costs,
            improve performance and provide real-time operational visibility.</b>
          </Reveal>
          <a href="/" className="prodback">← Back to main site</a>
        </div>
      </header>

      <section style={{ paddingTop: 30 }}>
        <div className="wrap">
          <div className="assetgrid">
            {CATEGORIES.map(([title, items], i) => (
              <Reveal className="rv" tag="div" key={title} style={{ transitionDelay: `${(i % 3) * 0.06}s` }}>
                <div className="assetcat" data-testid={`asset-cat-${i}`}>
                  <h3><span className="dot" />{title}</h3>
                  <ul>{items.map((it) => <li key={it}>{it}</li>)}</ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="benefits-sec">
        <div className="wrap">
          <Reveal className="eyebrow" tag="div">WHAT WE CAN DELIVER</Reveal>
          <Reveal className="h2" tag="div">Measurable Outcomes, <span className="g">Verified Continuously</span></Reveal>
          <div className="benefitgrid">
            {BENEFITS.map((b, i) => (
              <Reveal className="rv" tag="div" key={b} style={{ transitionDelay: `${(i % 2) * 0.05}s` }}>
                <div className="benefit" data-testid={`benefit-${i}`}>
                  <span className="ck">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                  </span>
                  {b}
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal tag="div" style={{ textAlign: "center", marginTop: 44 }}>
            <a href="/how-it-works" className="btn" data-testid="how-it-works-btn">Learn how Eniscope &amp; CII work →</a>
          </Reveal>
        </div>
      </section>

      <section className="assetbanner">
        <div className="wrap">
          <Reveal className="tm" tag="div">Making the Invisible Visible<span className="g">™</span></Reveal>
          <Reveal className="sub2" tag="div">Every asset has a story. We simply make sure you can see it.</Reveal>
          <Reveal className="quote" tag="div">
            If you can measure it, you can improve it. If you can monitor it continuously, you can optimise it.
          </Reveal>
          <Reveal tag="div" style={{ marginTop: 36 }}>
            <a href="/gap-analysis" className="btn" data-testid="assets-cta">Book Your Complimentary Gap Analysis</a>
          </Reveal>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <GapFloat />
    </div>
  );
}
